<template>
<div>

  <v-toolbar dense flat >
    <v-btn to='/settings/home' icon ><v-icon>settings</v-icon></v-btn>
    <v-toolbar-title>Settings</v-toolbar-title>
    <v-btn to='/settings/locations' flat >Spaces</v-btn>
    <v-btn to='/settings/profile' flat >Profile</v-btn>
    <v-spacer/>
    <v-btn small outline
      href='https://settings.appointmentguru.co'
      target='_blank' color='primary' >
      Advanced settings
      <v-icon small class='ml-2'>open_in_new</v-icon>
    </v-btn>
  </v-toolbar>

  <!-- <v-card class='mb-3 text-xs-left' >
    <div>
    <v-breadcrumbs :justify-center='false' divider=">" class='text-xs-left' >
      <v-breadcrumbs-item to='/settings/home' >
        Settings
      </v-breadcrumbs-item>
      <v-breadcrumbs-item :disabled='true' >{{currentPage}}</v-breadcrumbs-item>
    </v-breadcrumbs>
    </div>
  </v-card> -->
  <v-card class='grey lighten-4' >
    <v-card-text>
      <v-alert dismissible :value='(currentPage === "Spaces")'
        class="pa-1 " type="info" >
        <v-btn target="_blank" dark
          href="https://book.appt.guru/?p=1"
          style="float:right;" small outline >Book a consultation
          <v-icon small class='ml-2' >open_in_new</v-icon>
        </v-btn>
        <v-btn target="_blank" dark
          href="https://www.loom.com/share/c264dda3a91a4f37a2a0f57132ca3bad"
          style="float:right;" small outline >Watch a video
          <v-icon small class='ml-2' >ondemand_video</v-icon>
        </v-btn>
        Need help setting up your account?<br/>
        Book a one on one session with us to help you get the most out of AppointmentGuru
      </v-alert>
      <transition name='fade' default='Profile' mode='out-in' >
        <router-view></router-view>
      </transition>
    </v-card-text>
  </v-card>

</div>
</template>

<script>
import Profile from '@/components/pages/settings/Profile'
// import Communications from '@/components/settings/Communications'

export default {
  name: 'SettingsPage',
  components: {
    // Communications,
    Profile
  },
  data () {
    return {
      expanded: {
        profile: true
      },
      items: [1, 2, 3, 4, 5]
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
    currentPage () {
      return this.$route.name
    }
  }
}
</script>

<style scoped>
.breadcrumbs { justify-content: left; }
.horizontal-scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.horizontal-scrolling-wrapper .card {
  flex: 0 0 auto;
  min-width:100%
}
</style>



// WEBPACK FOOTER //
// Settings.vue?332579e8